import type { RootState } from "../../app/store.js";

export const selectInterview = (state: RootState) =>
  state.transcriptFragments.interview;
